import styled, { keyframes } from 'styled-components';

import closeIcon from 'assets/icons/close.svg';
import loadingSpinnerIcon from 'assets/icons/loadingSpinner.png';

export const rotate360 = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const ButtonSpinnerIcon = styled.img.attrs({
  'aria-label': 'Spinner Icon',
  src: loadingSpinnerIcon,
})`
  width: 1.5rem;
  height: 1.5rem;
  animation: ${rotate360} 1s steps(8, end) infinite;
`;

export const WarningIcon = styled.span.attrs(() => ({
  role: 'img',
  'aria-label': 'Warning Emoji',
  children: '⚠️',
}))`
  margin-right: 0.5rem;
`;

const StyledIcon = styled.img`
  display: block;
  margin: 1.5rem auto 0.75rem;
  width: 86px;
  height: auto;
`;

export const CloseIcon = styled(StyledIcon).attrs({
  alt: 'Close Modal',
  src: closeIcon,
})`
  margin: 0;
  width: 24px;
`;
